import { t } from '@angular/cdk/scrolling-module.d-ud2XrbF8';
import { computed, Injectable, signal } from '@angular/core';
import { IBISettingsPermission } from '@feature/settings/interfaces';
import { BehaviorSubject } from 'rxjs';
import { BISettingsPermissionsScreenCodes } from 'src/app/shared/common/permissionsList.enum';

@Injectable({
  providedIn: 'root',
})
export class SettingPermissionsService {
  settingScreensPermissions = signal<IBISettingsPermission[]>([]);
  settingScreensPermissions$ = new BehaviorSubject<IBISettingsPermission[]>([]);

  private readonly settingScreensPermissionsCodes = computed(() =>
    this.settingScreensPermissions().map(permission => permission.screenCode),
  );
  /**
   * Checks if the user has a specific permission.
   * @param permission The permission key from `BISettingsPermissionsScreenCodes`.
   * @returns `true` if the user has the specified permission, otherwise `false`.
   */
  hasPermission(
    permission: keyof typeof BISettingsPermissionsScreenCodes,
  ): boolean {
    const permissionValue = BISettingsPermissionsScreenCodes[permission];
    return this.settingScreensPermissionsCodes().includes(permissionValue);
  }

  /**
   * Checks if the user has any of the provided permissions.
   * @param permissions An array of permission keys from `BISettingsPermissionsScreenCodes`.
   * @returns `true` if the user has at least one of the specified permissions, otherwise `false`.
   */
  hasAnyPermission(
    permissions: (keyof typeof BISettingsPermissionsScreenCodes)[],
  ): boolean {
    return permissions.some(permission => this.hasPermission(permission));
  }

  getPagePermissions(
    page: (typeof BISettingsPermissionsScreenCodes)[keyof typeof BISettingsPermissionsScreenCodes],
  ): IBISettingsPermission | undefined {
    return this.settingScreensPermissions().find(p => p.screenCode === page);
  }
}
